import { Button } from "primereact/button";
import { useContext, useEffect, useMemo, useState } from "react";
import { RTLContext } from "../../App";
import axios from "axios";
import Message from "./Message";
import { Skeleton } from "primereact/skeleton";
import { superAdmin } from "../../lib/constants";

const NotificationComponent = () => {
    const { closeSidebar } = useContext(RTLContext);
    const [active, setActive] = useState("activity");
    const [notificationsData, setNotificationsData] = useState([]);
    const [activitysData, setActivityData] = useState([]);
    const [loading, setLoading] = useState(false);
    const serviceId = localStorage.getItem('serviceId');
    const uid = localStorage.getItem('userId');
    const designerId = localStorage.getItem('emailId');
    const baseUrlNotifcaions = process.env.REACT_APP_NOTIFICATION_API;
    const baseUrlActivity = process.env.REACT_APP_API_PARSER_URL;
    const apiKey = process.env.REACT_APP_NOTIFICATION_API_KEY;

    const isSuperAdmin = useMemo(() => {
        let arr = JSON.parse(localStorage.getItem("permissions")) ?? [];
        if (arr.includes(superAdmin)) return true;
    }, []);
    const fetchData = async () => {
        const activityPayload = {"serviceId": serviceId};
        if(!isSuperAdmin){
            activityPayload['designerID'] = designerId;
        }
        try {
            setLoading(true);
            const url = `${baseUrlNotifcaions}/notification/get?userId=${uid}&serviceId=${serviceId}`;
            const [res1, res2] = await Promise.all([axios.post(
                url,
                {},
                {
                    headers: {
                        accept: "application/json",
                        "x-api-key": apiKey,
                    },
                }
            ), axios.post(
                `${baseUrlActivity}/imaginehomes/fetchActivityLogs`,
                activityPayload,
                {
                    headers: {
                        accept: "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            )])
            if (res1.status === 200) {
                setNotificationsData(res1.data.notifications)
            }
            if (res2.status === 200) {
                setActivityData(res2.data.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const updateNotificationsStatus= async (notificationId) => {
        try {
            const url = `${baseUrlNotifcaions}/notification/read?notificationId=${notificationId}`;
            const res = await axios.post(
                url,
                {},
                {
                    headers: {
                        accept: "application/json",
                        "x-api-key": apiKey,
                    },
                }
            )
            if(res.data.status===200){
                setNotificationsData(prev =>
                    prev.map(item =>
                        item.notificationId === notificationId
                            ? { ...item, is_read:true }
                            : item
                    )
                );
            }
        } catch (err) {
            console.error(err);
        }
    };
    useEffect(() => {
        fetchData()
    }, [])
    const LoaderSkelton = () => {
        return (
            <div className="p-2">
                {Array.from({ length: 8}).map((_, i) => (
                    <div key={i} className="p-2 mb-2">
                        {/* Title */}
                        <Skeleton width="8rem" height="0.75rem" className="mb-2" />

                        {/* Description */}
                        <Skeleton width="70%" height="0.6rem" className="mb-2" />
                        {/* Divider */}
                        <div className="border-bottom-1 surface-border" />
                    </div>
                ))}
            </div>
        );
    }
    const timeFormat = process.env.REACT_APP_ENV === "dev" ? "DD-MM-YYYY HH:mm:ss" : "MM-DD-YYYY HH:mm:ss";
    return (
        <>
            <div className="flex align-items-center justify-content-between mb-3">
                <h2 className="m-0 capitalize" style={{ fontFamily: 'Larken' }}>{active}</h2>
                <Button icon="pi pi-times" className="p-button-text p-button-rounded" onClick={closeSidebar} aria-label="Close" />
            </div>
            <div className="toggle-wrapper">
                <div className="notificatios_toggle-container w-full">
                    <Button
                        label="Activity"
                        onClick={() => setActive("activity")}
                        style={{ fontFamily: 'Larken' }}
                        className={`notificatios_toggle-btn ${active === "activity" ? "active" : ""}`}
                    />
                    <Button
                        label="Notification"
                        style={{ fontFamily: 'Larken' }}
                        onClick={() => setActive("notification")}
                        className={`notificatios_toggle-btn ${active === "notification" ? "active" : ""}`}
                    />
                </div>
                {loading ? <LoaderSkelton/> : active === "activity" && <div className="mt-2">
                    {
                        activitysData?.length === 0 ? <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 50,
                                overflow: "hidden",
                                height: '100%',
                                padding: '50px'
                            }}
                        >
                            <p
                                style={{
                                    fontFamily: "Inter",
                                    fontSize: "16px",
                                    lineHeight: "16px",
                                    fontWeight: 400,
                                    letterSpacing: "-0.4px",
                                }}
                            >
                                No activities found!
                            </p>
                        </div> : <div className="overflow-y-scroll flex flex-column" style={{ height: "calc(100vh - 180px)", gap:'5px' }}>
                            {
                                activitysData?.map((item, index) => {
                                    return <Message readStatusHandler={()=>()=>{}} key={index} message={item.description ? item.description :''} isRead={true} time={item?.created_at} timeFormat="YYYY-MM-DD HH:mm:ss" />
                                })
                            }
                        </div>
                    }
                </div>}
                {loading ? <LoaderSkelton/> : active === "notification" && <div className="mt-2">
                    {
                        notificationsData?.length === 0 ? <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                zIndex: 50,
                                overflow: "hidden",
                                height: '100%',
                                padding: '50px'
                            }}
                        >
                            <p
                                style={{
                                    fontFamily: "Inter",
                                    fontSize: "16px",
                                    lineHeight: "16px",
                                    fontWeight: 400,
                                    letterSpacing: "-0.4px",
                                }}
                            >
                                No notifications found!
                            </p>
                        </div> : <div className="overflow-y-scroll flex flex-column" style={{ height: "calc(100vh - 180px)", gap:'5px' }}>
                            {
                                notificationsData?.map((item) => {
                                    return <Message readStatusHandler={()=>updateNotificationsStatus(item?.notificationId)} key={item?.notificationId} message={item?.message} isRead={item?.is_read} time={item?.created_at} timeFormat={timeFormat} />
                                })
                            }
                        </div>
                    }
                </div>}
            </div>
        </>
    );
};

export default NotificationComponent;
